// extracted by mini-css-extract-plugin
module.exports = {"slider":"Slider_slider__3kVKd","rotating":"Slider_rotating__3tolY"};